import React, { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    FormControlLabel,
    Checkbox,
    useTheme,
    IconButton,
} from "@mui/material";
import { addUser, getAllProperties, getAllRoles, updateUser } from "state/apis";
import { toast } from "react-toastify";
import { Close as CloseIcon } from "@mui/icons-material";
import Autocomplete from "@mui/material/Autocomplete";
const AddUser = ({ open, onClose, onSubmit, editData, editMode }) => {
    const theme = useTheme();
    const [role, setRole] = useState([]);
    const [property, setProperty] = useState([]);
    const [data, setData] = useState({
        name: "",
        email: "",
        password: "",
        roleId: "",
        propertyIds: [],
    });

    useEffect(() => {
        fetchRoles();
        fetchProperty();
    }, []);

    const fetchRoles = async () => {
        try {
            const res = await getAllRoles(1000, 0, "");
            setRole(res?.role);
        } catch (error) {
            toast.error("Failed to fetch data. Please try again.");
        }
    };
    const fetchProperty = async () => {
        try {
            const res = await getAllProperties(1000, 0, "");
            setProperty(res?.property);
        } catch (error) {
            toast.error("Failed to fetch data. Please try again.");
        }
    };

    useEffect(() => {
        if (editMode && editData) {
            const propertyIds =
                editData.userProperties?.map((userProperty) => userProperty.propertyId) || [];
            setData({
                id: editData?.id,
                name: editData?.name,
                email: editData?.email,
                password: "",
                roleId: editData?.roleId,
                propertyIds: propertyIds,
            });
        } else {
            setData({
                name: "",
                email: "",
                password: "",
                roleId: "",
                propertyIds: [],
            });
        }
    }, [editData, editMode]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleRoleChange = (newValue) => {
        setData((prevData) => ({
            ...prevData,
            roleId: newValue ? newValue.id : null,
        }));
    };

    const handlePropertyChange = (newValue) => {
        if (newValue) {
            const selectedPropertyIds = newValue.map((property) => property.id);

            setData((prevData) => ({
                ...prevData,
                propertyIds: selectedPropertyIds,
            }));
        } else {
            setData((prevData) => ({
                ...prevData,
                propertyIds: [],
            }));
        }
    };

    const handleSubmit = async () => {
        try {
            if (editMode) {
                const response = await updateUser(data.id, data);
                toast.success(response.message);
            } else {
                const response = await addUser(data);
                toast.success(response.message);
            }
            onSubmit();
            onClose();
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                {editMode ? "Edit User" : "Add User"}
                <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={12}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={role}
                            getOptionLabel={(option) => option.name}
                            value={data.roleId ? role.find((ele) => ele.id === data.roleId) : null}
                            onChange={(event, newValue) => handleRoleChange(newValue)}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.name}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Role" />
                            )}
                        />
                    </Grid>
                    {/* <Grid item xs={12}>
                        <Autocomplete
                            multiple
                            disablePortal
                            id="combo-box-demo"
                            options={property}
                            getOptionLabel={(option) => option.propertyName}
                            value={
                                data.propertyIds
                                    ? property.filter((ele) => data.propertyIds.includes(ele.id))
                                    : []
                            }
                            onChange={(event, newValue) => handlePropertyChange(newValue)}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.propertyName}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Properties" />
                            )}
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <Autocomplete
                            multiple
                            disablePortal
                            id="combo-box-demo"
                            options={[{ id: "all", propertyName: "All Properties" }, ...property]} // Add "All Properties" option
                            getOptionLabel={(option) => option.propertyName}
                            value={
                                data.propertyIds && data.propertyIds.length === property.length
                                    ? property // Show all properties when "All Properties" is selected
                                    : property.filter((ele) => data.propertyIds.includes(ele.id))
                            }
                            onChange={(event, newValue) => {
                                if (newValue.some((val) => val.id === "all")) {
                                    handlePropertyChange(property); // Select all properties
                                } else {
                                    handlePropertyChange(newValue); // Update with selected properties
                                }
                            }}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.propertyName}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Properties" />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Name"
                            name="name"
                            value={data.name}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Email"
                            name="email"
                            value={data.email}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Password"
                            name="password"
                            value={data.password}
                            onChange={handleChange}
                        />
                    </Grid>
                    {/* <Grid item xs={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={data.isAdmin}
                                    onChange={(e) =>
                                        setData({   
                                            ...data,
                                            isAdmin: e.target.checked,
                                        })
                                    }
                                    name="isAdmin"
                                    color="primary"
                                />
                            }
                            label="Is Admin"
                        />
                    </Grid> */}
                </Grid>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        {editMode ? "Update" : "Add"}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default AddUser;
